import React from 'react';
import cn from 'classnames';

import dotsThreeOutlineVertical from '../../../../icons/dotsThreeOutlineVertical.svg';
import styles from './homes.card.module.css'

const HomesCard = ({title, menu, total, amount, type = 'default'}) => {
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <span>
          {title}
        </span>
        {menu &&
          <button className={styles.button}>
            <img src={dotsThreeOutlineVertical} width="15px" height="15px"/>
          </button>
        }
      </div>
      <div>
        <span className={styles.amount}>{amount}</span>
      </div>
      <div className={styles.wrapper}>
        <div className={styles.bar}>
          <div className={cn(styles.progress, styles[type])} style={{ width: `${(amount / total) * 100}%` }}/>
        </div>
        {((amount / total) * 100).toFixed(0)}%
      </div>
    </div>
  );
};

export default HomesCard;
